import Vue from "vue";
import Vuex from "vuex";
import api from "./api";
import cfg from "../../public/static/cfg";
import medApi from "./medApi";
import dayjs from "dayjs";

Vue.use(Vuex);

// 刷卡数据
const cardInfoStorage = sessionStorage.getItem("cardInfo");
const cardInfoInit = {
  certno: "",
  uid: "",
  psn_cert_type: "",
  psn_name: "",
  psn_no: "",
  header: null,
  birth: "",
};
const cardInfo = cardInfoStorage ? JSON.parse(cardInfoStorage) : cardInfoInit;

// 当前医院信息（用于获取定点医药机构编号）
const hospitalStorage = sessionStorage.getItem("hospitalInfo");
const hospitalInfo = hospitalStorage
  ? JSON.parse(hospitalStorage)
  : {
      fixmedinsCode: "",
      fixmedinsName: "",
      mdtrtareaAdmvs: "",
      fixmedinsType: "1",
    };
const medCode = sessionStorage.getItem("medCode") || "020";

const payloadBase = {
  libsName: "gzsyb-lib/SSCard",
  nOutBuffLen: "1024",
  nSignBuffLen: "1024",
};
const readTypes = [
  "GetTwoBarCodes",
  "ReadIDCardGZ",
  "ReadCardBasGZ",
  "ReadMedicalCardGZ",
  "NationEcTrans",
];
// 测试 不可用 35020319001 1234567 20004004 35020311234  004001  440100  005001  300050725 0027432 19610413  01135324
// 测试 可用 H44010400081 H44011100775  H44010400363 H44011300130 H44010400073 H44011700805 H44010600019 H44010600090 H44152100083 H44011200122 H44010600007 H44150200051 H44011300130
// 正式 012104
const orgId = "012104"; // 机构编码

export default new Vuex.Store({
  state: {
    token: null,
    refToken: null,
    user: null,
    triageDept: null,
    setting: {
      defaultPageSize: 20,
    },
    theme: null,
    dict: {},
    medDict: {},
    permission: {
      isEmpty: true,
    },
    menus: {
      isEmpty: true,
      firstMenuList: [],
    },
    enum: {
      OpType: ["自费", "医保", "医保工伤"],
      DockingSolution: ["抽取", "推送"],
      RegState: ["空闲", "预约", "取号", "报到", "就诊", "完诊"],
      PeriodType: ["上午", "下午", "夜间"],
      OpRotaType: ["科室", "专家", "急诊"],
      InvoiceType: ["库存", "入库", "领用", "回收", "报损"],
      PaymentState: ["未支付", "收款", "退款"],
      PrescriptionType: ["药品", "检查治疗", "草药"],
      CriticalLevel: ["濒危", "危重", "急症", "非急症"],
      HealthSignType: [
        "收缩压",
        "舒张压",
        "呼吸频率",
        "体温",
        "心率",
        "血钾",
        "血糖",
        "血压",
        "血氧饱和度",
        "腋温",
      ],
      SourseInfo: ["本市", "外市"],
      OffsetFlag: ["正常", "原单", "冲单"],
      PaymentType: ["收费", "退费"],
      DiscountWay: ["全免费", "免挂号费", "免其他费"],
      DiscountType: ["挂号", "门诊"],
      NationalPhysiciansOrderState: ["已收费", "审核通过", "审核驳回", "作废"],
      SetlType: ["门诊结算", "门诊单据式结算"],
    },
    hospitalInfo, // 当前 定点医药机构信息（编号、名称）
    medCode, // 全局的 医保类型
    cardInfo, // 全局的 刷卡数据
    triage: [],

    // 德卡ws相关
    ws: null, // 当前连接实例
    wsLoading: false, // 初始化
    sendLoading: false, // 发送消息
    readCardRawData: null, // 接收到的原始数据 - JSON string
    readCardType: "", // 输入参数类型，bka100社保卡卡号；aac002社会保障号码；qrcode 电子社保卡二维码；bac028 医疗证号
    readCardTime: dayjs().valueOf(), // 读卡时间
    callback: null, // 接收消息之后的 callback
    errCallback: null,
    resultCode: -1, // 医保通讯返回状态，0成功，-1初始化失败，-300000需要初始化
    insuplc_admdvs: "440100",
  },
  getters: {
    getTriage: (state) => {
      if (!state.triage.length) {
        state.triage = JSON.parse(localStorage.getItem("triage"))
          ? JSON.parse(localStorage.getItem("triage"))
          : [];
      }
      return state.triage;
    },
    triageDept: (state) => {
      if (!state.triageDept) {
        state.triageDept = localStorage.getItem("triageDept");
      }
      return state.triageDept;
    },
    token: (state) => {
      if (!state.token) {
        state.token = sessionStorage.getItem("token");
      }
      // 生产环境时请务必将setting.token设置为null！！！
      return cfg.token || state.token;
    },
    refToken: (state) => {
      if (!state.refToken) {
        state.refToken = sessionStorage.getItem("refToken");
      }
      return state.refToken;
    },
    user: (state) => {
      if (!state.user) {
        const userJson = sessionStorage.getItem("user");
        if (userJson) {
          state.user = JSON.parse(userJson);
        }
      }
      return state.user;
    },
    permission: (state) => {
      if (!state.permission || state.permission.isEmpty) {
        let permissionJson = sessionStorage.getItem("permission");
        if (permissionJson) {
          state.permission = JSON.parse(permissionJson);
        } else {
          state.permission = {
            isEmpty: true,
          };
        }
      }
      return state.permission;
    },
    menus: (state) => {
      if (state.menus.isEmpty) {
        let menus = sessionStorage.getItem("menus");
        if (menus) {
          state.menus = JSON.parse(menus);
        }
      }
      return state.menus;
    },
    setting: (state) => {
      if (!state.setting) {
        const settingJson = sessionStorage.getItem("setting");
        if (settingJson) {
          state.setting = JSON.parse(settingJson);
        }
      }
      return state.setting;
    },
    theme: (state) => {
      if (!state.theme) {
        let jsn = localStorage.getItem("theme");
        if (jsn) {
          state.theme = JSON.parse(jsn);
        }
      }
      if (!state.theme) {
        state.theme = {};
      }
      return state.theme;
    },
    dict: (state) => {
      if (!state.dict || Object.keys(state.dict).length === 0) {
        const dictJson = localStorage.getItem("dict");
        if (dictJson) {
          state.dict = JSON.parse(dictJson);
        }
      }
      return state.dict;
    },
    medDict: (state) => {
      if (!state.medDict || Object.keys(state.medDict).length === 0) {
        const dictJson = localStorage.getItem("medDict");
        if (dictJson) {
          state.medDict = JSON.parse(dictJson);
        }
      }
      return state.medDict;
    },
    getDict: (state, getters) => (type, emptyFirst) => {
      let dict = [];
      if (getters.dict[type]) {
        dict = JSON.parse(JSON.stringify(getters.dict[type]));
      }
      if (emptyFirst) {
        dict.unshift({
          code: null,
          text: "",
        });
      }
      return dict;
    },
    getMedDict: (state, getters) => (type, emptyFirst) => {
      let medDict = [];
      if (getters.medDict[type]) {
        medDict = JSON.parse(JSON.stringify(getters.medDict[type]));
      }
      if (emptyFirst) {
        medDict.unshift({
          code: null,
          text: "",
        });
      }
      return medDict;
    },
    Enum: (state) => {
      let en = {};
      Object.keys(state.enum).forEach((k) => {
        en[k] = {};
        state.enum[k].forEach((e) => {
          en[k][e] = e;
        });
      });
      return en;
    },
    dictEnum: (state) => {
      let en = {};
      Object.keys(state.enum).forEach((k) => {
        en[k] = state.enum[k].map((e) => ({
          code: e,
          text: e,
          value: e,
          name: e,
        }));
      });
      return en;
    },
  },

  mutations: {
    testReadCardRawData(state, payload) {
      state.readCardRawData = payload;
      const arr = payload.pOutInfo.pOutInfo.split("|");
      // 得到身份证号
      state.readCardRawData.pOutInfo.certno = arr[1];
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i].length; j++) {
          const charCode = arr[i][j].charCodeAt(j);
          // 检查是否在基本汉字区，是否包含中文字符
          if (charCode >= 0x4e00 && charCode <= 0x9fa5) {
            // 得到姓名
            state.readCardRawData.pOutInfo.psn_name = arr[i];
            break;
          }
        }
      }

      // 得到出生日期
      const birthDateStr = arr[1].slice(6, 14); // 提取出生日期部分（第7到14位）
      // 将其分割为年、月、日
      const year = birthDateStr.slice(0, 4);
      const month = birthDateStr.slice(4, 6);
      const day = birthDateStr.slice(6, 8);
      state.readCardRawData.pOutInfo.birth = `${year}-${month}-${day}`;
    },
    setReadCardRawData(state, { mdtrt_cert_type, psn_cert_type }) {
      state.readCardRawData.pOutInfo.mdtrt_cert_type = mdtrt_cert_type;
      state.readCardRawData.pOutInfo.psn_cert_type = psn_cert_type;
    },
    //分诊配置
    triage(state, triageItem) {
      state.triage = [triageItem];
      localStorage.setItem("triage", JSON.stringify([triageItem]));
    },
    triageDept(state, triageDept) {
      state.triageDept = triageDept;
      localStorage.setItem("triageDept", triageDept);
    },
    token(state, token) {
      state.token = token;
      sessionStorage.setItem("token", token);
    },
    refToken(state, refToken) {
      state.refToken = refToken;
      // if (cfg.isDev) {
      // 生产环境不要保存
      sessionStorage.setItem("refToken", refToken);
      // }
    },
    user(state, user) {
      state.user = user;
      // if (cfg.isDev) {
      // 生产环境不要保存
      sessionStorage.setItem("user", JSON.stringify(user));
      // }
    },
    permission(state, items) {
      if (items && items.length) {
        state.permission.isEmpty = false;
        state.permission.items = items;
        items.forEach((item) => {
          state.permission[item] = true;
        });
        // if (cfg.isDev) {
        sessionStorage.setItem("permission", JSON.stringify(state.permission));
        // }
      }
    },
    menus(state, items) {
      if (items.firstMenu && items.firstMenu.length) {
        state.menus.isEmpty = false;
        state.menus.firstMenu = items.firstMenu;
      }
      if (items.firstMenuList && items.firstMenuList.length) {
        state.menus.isEmpty = false;
        state.menus.firstMenuList = items.firstMenuList;
      }
      if (items.menuList && items.menuList.length) {
        state.menus.isEmpty = false;
        state.menus.menuList = items.menuList;
      }
      sessionStorage.setItem("menus", JSON.stringify(state.menus));
    },
    setting(state, setting) {
      if (setting.items) {
        setting.items.forEach((item) => {
          const options = item.options ? JSON.parse(item.options) : null;
          if (options && options.type == "bool") {
            state.setting[item.code] = JSON.parse(item.value);
          } else {
            state.setting[item.code] = item.value;
          }
        });
      }
      sessionStorage.setItem("setting", JSON.stringify(state.setting));
    },
    theme(state, theme) {
      state.theme = theme;
      localStorage.setItem("theme", JSON.stringify(state.theme));
    },
    dict(state, dict) {
      state.dict[dict.type] = dict.items;
      localStorage.setItem("dict", JSON.stringify(state.dict));
    },
    medDict(state, medDict) {
      state.medDict[medDict.type] = medDict.items;
      localStorage.setItem("medDict", JSON.stringify(state.medDict));
    },
    clear(state) {
      try {
        sessionStorage.removeItem("token");
        state.token = null;
        state.tokenExp = null;
        sessionStorage.removeItem("refToken");
        state.refToken = null;
        sessionStorage.removeItem("user");
        state.user = null;
        sessionStorage.removeItem("setting");
        state.setting = null;
        state.token = null;
        state.permission = {
          isEmpty: true,
        };
        sessionStorage.removeItem("permission");
        sessionStorage.removeItem("menus");
        sessionStorage.removeItem("hospitalInfo");
        sessionStorage.removeItem("cardInfo");
        sessionStorage.removeItem("medCode");
        state.menus = {
          isEmpty: true,
        };
      } catch (e) {
        console.log(e);
      }
    },
    setHospitalInfo(state, val) {
      state.hospitalInfo = val;
      sessionStorage.setItem("hospitalInfo", JSON.stringify(val));
    },
    // 医保类型
    setMedCode(state, val) {
      state.medCode = val;
      sessionStorage.setItem("medCode", val);
    },
    // 医保类型
    setInsuplcAdmdvs(state, val) {
      state.insuplc_admdvs = val;
    },
  },
  actions: {
    loadDicts({ commit, state }, types) {
      if (!(types instanceof Array)) {
        types = [types];
      }
      const dicts = [];
      types.forEach((type) => {
        if (!state.dict[type] || !state.dict[type].length) {
          switch (type) {
            case "RegType":
              api
                .queryRegType({
                  pageSize: 99999,
                  pageIndex: 1,
                })
                .then((res) => {
                  res.items.forEach((item) => {
                    item.text = item.name;
                    item.value = item.code;
                    item.shortCode = item.shortCode || item.code;
                  });
                  let dict = {
                    type: type,
                    items: res.items,
                  };
                  commit("dict", dict);
                })
                .catch((err) => {
                  console.log(err);
                });
              break;
            case "AppointmentChannel":
              api
                .queryChannel({
                  pageSize: 99999,
                  pageIndex: 1,
                })
                .then((res) => {
                  res.items.unshift({
                    code: 0,
                    name: "本院",
                  });
                  res.items.forEach((item) => {
                    item.text = item.name;
                    item.value = item.code;
                    item.shortCode = item.shortCode || item.code;
                  });

                  let dict = {
                    type: type,
                    items: res.items,
                  };
                  commit("dict", dict);
                })
                .catch((err) => {
                  console.log(err);
                });
              break;
            case "OpTarget":
              api
                .queryTarget({
                  pageSize: 99999,
                  pageIndex: 1,
                })
                .then((res) => {
                  res.items.forEach((item) => {
                    item.code = item.doctorId || item.deptCode;
                    item.name = item.doctorName || item.deptName;
                    item.text = item.name;
                    item.value = item.code;
                    item.shortCode = item.shortCode || item.code;
                  });

                  let dict = {
                    type: type,
                    items: res.items,
                  };
                  commit("dict", dict);
                })
                .catch((err) => {
                  console.log(err);
                });
              break;
            case "Dept":
              api
                .queryDept({
                  pageSize: 99999,
                  pageIndex: 1,
                })
                .then((res) => {
                  // 只要门诊科室.filter(i => i.ifOp), ifOp: true
                  res.items.forEach((item) => {
                    item.text = item.name;
                    item.value = item.code;
                    item.shortCode = item.shortCode || item.code;
                  });

                  let dict = {
                    type: type,
                    items: res.items,
                  };
                  commit("dict", dict);
                })
                .catch((err) => {
                  console.log(err);
                });
              break;
            case "DrugFrequency":
              api
                .queryFrequency({
                  pageIndex: 1,
                  pageSize: 999,
                })
                .then((res) => {
                  commit("dict", {
                    type: type,
                    items: res.items.filter((t) => t.frequencyType === "西药"),
                  });
                  commit("dict", {
                    type: "TherapyFrequency",
                    items: res.items.filter((t) => t.frequencyType === "治疗"),
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
              break;
            case "PrintTemplate":
              api
                .getPrintTemplate()
                .then((res) => {
                  commit("dict", {
                    type: type,
                    items: res.items,
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
              break;
            default:
              dicts.push(type);
          }
        }
      });
      api
        .queryDict("", {
          types: dicts,
        })
        .then((res) => {
          if (res && res.items) {
            dicts.forEach((type) => {
              if (!state.dict[type] || !state.dict[type].length) {
                res.items
                  .filter((t) => t.type === type)
                  .forEach((item) => {
                    item.name = item.text;
                    item.value = item.code;
                    item.shortCode = item.shortCode || item.code;
                  });
                const items = res.items.filter((t) => t.type === type);
                if (type === "PayWay") {
                  // 支付方式按seqNo 排序
                  items.sort((a, b) => {
                    return a.seqNo - b.seqNo;
                  });
                }
                commit("dict", {
                  type: type,
                  items,
                });
              }
            });
          }
        });
    },
    unloadDicts({ state }, types) {
      if (!(types instanceof Array)) {
        types = [types];
      }
      types.forEach((type) => {
        delete state.dict[type];
      });
      localStorage.setItem("dict", JSON.stringify(state.dict));
    },
    clearDicts({ state }) {
      state.dict = {};
      localStorage.setItem("dict", JSON.stringify(state.dict));
    },
    loadMedDicts({ commit, state, dispatch }, types) {
      if (!(types instanceof Array)) {
        types = [types];
      }
      medApi.queryMedDict(types).then((res) => {
        if (!res || !res.length) return;
        types.forEach((type) => {
          const items = res.filter((t) => t.dicTypeCode === type);
          items.forEach((item) => {
            item.code = item.placeDicValCode;
            item.name = item.placeDicName;
            item.value = item.placeDicValCode;
            item.text = item.placeDicName;
            item.shortCode = item.placeDicValCode;
          });
          commit("medDict", {
            type: type,
            items: items
              ? items.sort((a, b) => {
                  return parseFloat(a.seq) - parseFloat(b.seq);
                })
              : [],
          });
        });
      });
    },
    clearMedDicts({ state }) {
      state.medDict = {};
      localStorage.setItem("medDict", JSON.stringify(state.medDict));
    },
    // 通过医保编号，获取医院在医保系统里的名称
    getHospitalInfoInMedSys({ dispatch, commit }, data) {
      api
        .getMedicalInsurance({ currentPage: 1, pageSize: 20 })
        .then(({ items }) => {
          if (Array.isArray(items) && items[0]) {
            commit("setHospitalInfo", {
              fixmedinsCode: items[0].fixmedinsCode,
              fixmedinsName: items[0].fixmedinsName, // 医保系统里的医药机构名称
              fixmedinsType: "", // 定点医疗服务机构类型
              mdtrtareaAdmvs: "", // 就医地行政区划编码 440100
            });
          }
        });
    },
    init({ dispatch, commit }) {
      dispatch("clearDicts");
      dispatch("loadDicts", [
        "InsuranceType",
        "IdType",
        "Ethnicity",
        "Marriage",
        "BeijingDistrict",
        "Nationality",
        "DockingSolution",
        "RegType",
        "AppointmentChannel",
        "OpTarget",
        "Gender",
        "Dept",
        "PatientSrc",
        "SignCode",
        "AgeGroup",
        "SourceDesc",
        "Consciousness",
        "PatientSource",
        "SpecialGroup",
        "VisitingType",
        "DrugType",
        "DrugFrequency",
        "DrugClaimType",
        "AppType",
        "CheckWay",
        "Parts",
        "SpecimenType",
        "PrintTemplate",
        "FeeType",
        "Constitution",
        "PayWay",
        "RebateType",
        "TestTube",
      ]);
      api
        .getSetting({
          sysCode: "auth",
          code: "theme",
        })
        .then((res) => {
          if (res.items && res.items.length) {
            let authTheme = JSON.parse(res.items[0].value);
            let theme = authTheme.reg;
            theme.copyright = authTheme.copyright;
            theme.icp = authTheme.icp;
            commit("theme", theme);
          }
        });
    },
    initMed({ dispatch, commit }) {
      medApi.queryMedCode().then((res) => {
        if (!res || !res.length) return;
        res.forEach((item) => {
          item.name = item.medName;
          item.value = item.medCode;
          item.code = item.medCode;
          item.text = item.medName;
          item.shortCode = item.medCode;
        });
        commit("medDict", {
          type: "med_code",
          items: res,
        });
        dispatch("getHospitalInfoInMedSys");
        // 获取IpMac
        medApi.getIpMac(res[0].medCode).then((result) => {
          if (!result) return;
          // 签到
          medApi.medLogin(res[0].medCode, {
            header: result,
            input: {},
          });
        });
      });
      dispatch("clearMedDicts");
      dispatch("loadMedDicts", [
        "bydise_setl_list_code",
        "rx_circ_flag",
        "psn_setlway",
        "acct_used_flag",
        "matn_type",
        "fixmedins_type", // 定点机构类型
        "med_type",
        "naty",
        "psn_cert_type",
        "gend",
        "cvlserv_flag",
        "insutype",
        "psn_type", // 人员类别
        "mdtrt_cert_type",
        "mdtrt_type",
        "mid_setl_flag",
        "matn_fee_flag",
        "matn_use_flag", // 生育使用标志
        "matn_type", // 生育类别
        "birctrl_type", // 计划生育手术类别
        "med_trt_type",
        "med_type_14", // 待遇类型
        "nat_regn_code", // 国籍
        "biz_appy_type", // 业务申请类型
        "agnter_rlts", // 代办人关系
        "fund_pay_type",
        "clr_type",
        "trt_chk_type", // 待遇检查类型
        "trt_enjymnt_flag", // 基金款项待遇享受标志
        "med_chrgitm_type",
      ]);
    },

    deCardWsInit({ state, dispatch }, { message, callback }) {
      if (state.ws) {
        if (state.resultCode === -1 || state.resultCode === -300000 || false) {
          message.info("正在尝试初始化，请稍候...");
          dispatch("paramsInit");
          return;
        }
        message.info("【强式-Server】已连接，请继续业务操作！");
      } else {
        try {
          message.info("正在尝试连接【强式-Server】程序，请稍候...");
          state.wsLoading = true;
          // state.ws = new WebSocket(`ws://127.0.0.1:8899`);
          state.ws = new WebSocket(`ws://127.0.0.1:13242`);
          state.ws.onopen = (event) => {
            // 建立连接之后，自动初始化参数
            dispatch("paramsInit");
          };
          state.ws.onmessage = (event) => {
            // 处理接收消息 event.data
            const { data } = event;
            console.log("接收到的原始数据 data ：");
            console.log(data);
            try {
              let _data = data;
              if (state.readCardType == "qrcode") {
                _data = _data.replace('"{', "{").replace('}"', "}");
              }
              const response = JSON.parse(_data);
              console.log("接收数据JSON解析后的结果：");
              console.log(response);
              const msg = response.reinfo || response.message;
              state.resultCode = response.result;
              if (response.result === 0) {
                if (readTypes.some((x) => x === response.function)) {
                  state.readCardRawData = response;

                  if (response.function != "NationEcTrans") {
                    const arr = response.pOutInfo.pOutInfo.split("|");
                    // 得到身份证号
                    state.readCardRawData.pOutInfo.certno = arr[1];
                    for (let i = 0; i < arr.length; i++) {
                      for (let j = 0; j < arr[i].length; j++) {
                        const charCode = arr[i][j].charCodeAt(j);
                        // 检查是否在基本汉字区，是否包含中文字符
                        if (charCode >= 0x4e00 && charCode <= 0x9fa5) {
                          // 得到姓名
                          state.readCardRawData.pOutInfo.psn_name = arr[i];
                          break;
                        }
                      }
                    }

                    // 得到出生日期
                    const birthDateStr = arr[1].slice(6, 14); // 提取出生日期部分（第7到14位）
                    // 将其分割为年、月、日
                    const year = birthDateStr.slice(0, 4);
                    const month = birthDateStr.slice(4, 6);
                    const day = birthDateStr.slice(6, 8);
                    state.readCardRawData.pOutInfo.birth = `${year}-${month}-${day}`;

                    state.readCardRawData.pOutInfo.card_sn = arr[3] ?? "";

                    state.readCardTime = dayjs().valueOf();
                    state.sendLoading = false;
                    state.callback();
                    state.callback = null;
                  } else {
                    state.readCardRawData.pOutInfo.certno =
                      response.pOutInfo.ecToken;
                    state.readCardTime = dayjs().valueOf();
                    state.sendLoading = false;
                    state.callback(response.pOutInfo);
                    state.callback = null;
                  }
                } else if (response.function === "Init") {
                  state.sendLoading = false;
                  message.success("初始化成功！");
                } else if (response.function === "") {
                  state.wsLoading = false;
                  message.success("【强式-Server】连接成功！");
                } else if (msg) {
                  message.warning(msg);
                }
              } else if (
                response.result === -1 ||
                response.result === -300000
              ) {
                message.info("正在尝试初始化，请稍候...");
                dispatch("paramsInit");
                state.errCallback && state.errCallback();
              } else {
                message.error(msg || "接收消息格式不正确！");
                state.readCardRawData = null;
                state.wsLoading = false;
                state.sendLoading = false;
                state.errCallback && state.errCallback();
              }
            } catch (e) {
              message.error(
                e.message || "连接失败，请先打开【强式-Server】程序再刷新页面！"
              );
              state.readCardRawData = null;
              state.wsLoading = false;
              state.sendLoading = false;
              state.errCallback && state.errCallback();
            }
          };
          state.ws.onclose = (event) => {
            state.ws = null;
            state.wsLoading = false;
            state.sendLoading = false;
            console.log(
              "服务连接关闭，请刷新页面重试！",
              dayjs().format("YYYY-MM-DD HH:mm:ss"),
              event
            );
            message.error("连接关闭，请先检查【强式-Server】状态再刷新页面！");
          };
          state.ws.onerror = (event) => {
            state.ws = null;
            state.wsLoading = false;
            state.sendLoading = false;
            state.readCardRawData = null;
            console.log(
              "服务连接失败，请先打开医保通讯程序！",
              dayjs().format("YYYY-MM-DD HH:mm:ss"),
              event
            );
            message.error("连接失败，请先打开【强式-Server】程序再刷新页面！");
          };
        } catch (e) {
          state.wsLoading = false;
          message.error(
            e.message || "连接失败，请先打开【强式-Server】程序再刷新页面！"
          );
        }
      }
    },
    paramsInit({ state }) {
      state.sendLoading = true;
      setTimeout(() => {
        const payload = {
          libsName: payloadBase.libsName,
          function: "Init",
          // 国医 正式 失败
          // pUrl: 'http://igb.hsa.gdgov.cn/prd_nation_eccode/prd_eccode/localcfc/api/hsecfc/localQrCodeQuery',
          // 国医 测试 失败
          // pUrl: 'http://igb.hsa.gdgov.cn/tst_nation_eccode/tst_eccode/localcfc/api/hsecfc/localQrCodeQuery',
          // 正式地址 基本医保读卡地址
          // pUrl: 'http://igb.hsa.gdgov.cn/gdyb_api/prd/api/card/initDll',
          // 容灾中心，电信、广宽
          pUrl: "http://hosp-gz.gd.hsip.gov.cn/gdyb_api/prd_gz/api/card/initDll",
          // 电子医保凭证
          // pUrl: 'http://hosp-gz.gd.hsip.gov.cn/prd_nation_eccode/prd_eccode/localcfc/api/hsecfc/localQrCodeQuery',
          pUser: orgId,
        };
        state.ws.send(JSON.stringify(payload));
      }, 300);
    },
    sendQR({ state, dispatch }, { message, callback }) {
      state.readCardType = "qrcode";
      const payload = {
        ...payloadBase,
        function: readTypes[0],
      };
      console.log("电子医保二维码入参：", JSON.stringify(payload));
      state.callback = callback;
      dispatch("doSendCard", { payload, message, callback });
    },
    sendCard({ state, dispatch }, { message, callback }) {
      state.readCardType = "aac002";
      const payload = {
        ...payloadBase,
        function: readTypes[1],
      };
      console.log("身份证入参：", JSON.stringify(payload));
      state.callback = callback;
      dispatch("doSendCard", { message, payload });
    },
    sendCardSB({ state, dispatch }, { message, callback }) {
      state.readCardType = "aac002";
      const payload = {
        ...payloadBase,
        function: readTypes[2],
      };
      console.log("社保卡入参：", JSON.stringify(payload));
      state.callback = callback;
      dispatch("doSendCard", { message, payload });
    },
    sendCardYB({ state, dispatch }, { message, callback }) {
      state.readCardType = "aac002";
      const payload = {
        ...payloadBase,
        function: readTypes[3],
      };
      console.log("医保卡入参：", JSON.stringify(payload));
      state.callback = callback;
      dispatch("doSendCard", { message, payload });
    },
    doSendCard({ state }, { payload, message, callback }) {
      if (state.wsLoading) {
        message.warning("正在建立连接，请稍候...");
        return;
      }
      if (state.sendLoading) {
        message.warning("请等待上次请求处理完毕...");
        return;
      }
      if (!state.ws) {
        dispatch("deCardWsInit", { message, callback });
        state.callback = null;
        return;
      }
      state.sendLoading = true;
      state.ws.send(JSON.stringify(payload));
    },
    scanCodeDK({ state }, { payload, readCardType, callback, errCallback }) {
      state.readCardType = readCardType;
      state.ws.send(payload);
      state.callback = callback;
      state.errCallback = errCallback;
    },
    clearReadCardRawData({ state }) {
      state.readCardRawData = null;
      state.readCardType = "";
    },
  },
});
